var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Info',[_vm._v(" Oh no, the page you're looking for can't be found! ")])}
var staticRenderFns = []

export { render, staticRenderFns }